import Cookies from "js-cookie";

export const getUrlParams = (input: string) => {
  const params = new URLSearchParams(input);
  return params;
};

export const getCookie = (name: string) => {
  const cookieValue = Cookies.get(name);
  return cookieValue;
};

export const setCookie = (name: string, value: string) => {
  Cookies.set(name, value, { secure: true, sameSite: "strict" });
};

export const removeCookie = (name: string) => {
  Cookies.remove(name);
};

const CONSTRUCT_IT_DOMAINS = [
  "tms-constructit.bjshomedelivery.com",
  "staging.tms-constructit.bjshomedelivery.com",
  "development.tms-constructit.bjshomedelivery.com",
];

// organisation (client) ids per environment, same pattern as DMS getClientId
const CLIENT_IDS: Record<string, Record<"haulage" | "constructIt", number>> = {
  development: { haulage: 2, constructIt: 3 },
  staging: { haulage: 2, constructIt: 3 },
  production: { haulage: 2, constructIt: 3 },
};

export const isConstructItOrigin = (origin: string): boolean =>
  CONSTRUCT_IT_DOMAINS.some((domain) => origin.includes(domain));

export const getClientId = (type: "haulage" | "constructIt"): number => {
  const projectEnv = process.env.REACT_APP_PROJECT_ENV || "production";
  return (CLIENT_IDS[projectEnv] || CLIENT_IDS.production)[type];
};

// begin_login sends ?constructClient=true on Construct IT domains -> Construct IT org, otherwise Haulage
export const getDefaultOrganisationId = (origin: string): number =>
  getClientId(isConstructItOrigin(origin) ? "constructIt" : "haulage");
